import Sort from "../../../assets/img/admin/sort.png";

export const SubscribersList = ({ subscriptions }) => {
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-x-auto">
      <table className="min-w-full table-fixed text-sm border border-gray-300">
        <thead className="bg-[#4F22D8] text-white text-base">
          <tr>
            <th className="py-3 px-4 text-left font-bold border-r border-gray-400">
              <button className="flex items-center gap-2">
                No
                <img src={Sort} alt="sort" className="w-4 h-4 object-contain" />
              </button>
            </th>
            <th className="py-3 px-4 text-left font-bold border-r border-gray-400">
              Email ID
            </th>
            <th className="py-3 px-4 text-left font-bold">Date and Time</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.map((sub, idx) => (
            <tr
              key={sub.value}
              className="border-t border-gray-300 font-normal text-[15px] hover:bg-gray-50 transition-colors"
            >
              <td className="px-4 py-3 text-black border-r border-gray-300">
                {idx + 1}
              </td>
              <td className="px-4 py-3 text-black border-r border-gray-300">
                {sub.email}
              </td>
              <td className="px-4 py-3 text-black">
                {formatDateTime(sub.subscribedAt)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
